import { render, staticRenderFns } from "./TrainShow.vue?vue&type=template&id=583ee196&scoped=true"
import script from "./TrainShow.vue?vue&type=script&lang=js"
export * from "./TrainShow.vue?vue&type=script&lang=js"
import style0 from "./TrainShow.vue?vue&type=style&index=0&id=583ee196&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ee196",
  null
  
)

export default component.exports